import PropTypes from "prop-types";

import styles from "./styles.module.css";

const ListItem = ({ icon, label, handleClick }) => {
  return (
    <li onClick={handleClick}>
      <span className={styles.iconWrap}>{icon}</span>
      <span className={styles.listValue}>{label}</span>
    </li>
  );
};

ListItem.propTypes = {
  icon: PropTypes.element,
  label: PropTypes.string,
  handleClick: PropTypes.func,
};

export default ListItem;
